import { Slider } from '../controls/Slider';
import { useActive } from './useActive';
import { useUi } from '../../state/ui';
import { useT } from '../../i18n';

/** §6.6 Detail: sharpening with edge masking, then noise reduction. Shown open = judged at 100%. */
export function DetailPanel() {
  const t = useT();
  const { settings, update } = useActive();
  const zoom = useUi((s) => s.zoom);
  const d = settings.detail;
  return (
    <div>
      {zoom !== 1 && (
        <div data-testid="zoom-note" style={{ fontSize: 12, marginBottom: 6, opacity: 0.8 }}>
          {t('zoomNote')}
        </div>
      )}
      <Slider
        label="sharpAmount"
        testId="slider-sharp-amount"
        value={d.sharpAmount}
        min={0}
        max={150}
        step={1}
        onChange={(v, f) => update((s) => void (s.detail.sharpAmount = v), f)}
      />
      <Slider
        label="sharpRadius"
        testId="slider-sharp-radius"
        value={d.sharpRadius}
        min={0.5}
        max={3}
        step={0.1}
        digits={1}
        defaultValue={1}
        onChange={(v, f) => update((s) => void (s.detail.sharpRadius = v), f)}
      />
      <Slider
        label="sharpMasking"
        testId="slider-sharp-masking"
        value={d.sharpMasking}
        min={0}
        max={100}
        step={1}
        onChange={(v, f) => update((s) => void (s.detail.sharpMasking = v), f)}
      />
      <Slider
        label="nrLuma"
        testId="slider-nr-luma"
        value={d.nrLuma}
        min={0}
        max={100}
        step={1}
        onChange={(v, f) => update((s) => void (s.detail.nrLuma = v), f)}
      />
      <Slider
        label="nrColor"
        testId="slider-nr-color"
        value={d.nrColor}
        min={0}
        max={100}
        step={1}
        onChange={(v, f) => update((s) => void (s.detail.nrColor = v), f)}
      />
    </div>
  );
}
